import React from 'react';

import CircleIcon from '@mui/icons-material/Circle';

import classes from './ScoreLegend.module.scss';
import { Status } from '../../../../shared/components/ui-components';

const ScoreLegend = () => {
  return (
    <div className={classes.scoreRow}>
      <Status icon={<CircleIcon fontSize="large" color="secondary" />}>All System</Status>
      <Status icon={<CircleIcon fontSize="large" color="primary" />}>My clients</Status>
    </div>
  );
};

export { ScoreLegend };
